import React, { ReactNode } from "react";
import { ChakraProvider, createSystem, defaultConfig, SystemConfig } from "@chakra-ui/react";
import { biblioteksentralenChakraTheme } from "./styles/chakraTheme/biblioteksentralenChakraTheme";
import { ColorModeProvider } from "@chakra-ui/system";

interface Props {
  children: ReactNode;
  customTheme?: SystemConfig;
}

export const BiblioteksentralenProvider = (props: Props) => (
  <ChakraProvider value={createSystem(defaultConfig, biblioteksentralenChakraTheme, props.customTheme || {})}>
    <ColorModeProvider {...props} />
  </ChakraProvider>
);
